<template>
  <!-- 텍스트 배너 -->
  <div
    v-if="textBanner.length > 0"
    class="text-banner"
  >
    <ul>
      <li
        v-for="banner in textBanner"
        :key="banner.id"
      >
        <a
          v-if="banner.contentType === 1"
          @click="handleDrugInfoClick(banner.contentId)"
        >
          <span class="info-type banner-item">약품정보</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 2"
          @click="handleMedicalTrendClick(banner.contentId)"
        >
          <span class="trend-type banner-item">메디컬 트렌드</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 3"
          @click="handleSurveyClick(banner.contentId)"
        >
          <span class="survey-type banner-item">설문조사</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 5"
          @click="handleWebseminarClick(banner.contentId)"
        >
          <span class="seminar-type banner-item">웹세미나</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 6"
          @click="handleNoticeClick(banner.contentId)"
        >
          <span class="notice-type banner-item">공지사항</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 7"
          @click="handleEventClick(banner.contentId)"
        >
          <span class="event-type banner-item">이벤트</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>

        <a
          v-else-if="banner.contentType === 8"
          @click.prevent="handleDrugLandingClick(banner.contentId)"
        >
          <span class="medical-type banner-item">간편처방 등록</span>
          <span class="banner-txt">{{ banner.bannerText }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SNT } from '@/core/global/global-enums'
import eventBus from '@/libs/event/event-bus'
import { liveInfoEventHandler } from '@/core/global/global-liveinfo'

export default {
  components: {
  },
  data() {
    return {
      textBanner: []
    }
  },
  computed: {
    ...mapGetters({
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      shaEnLicenseNum: 'infoData/getShaEnLicenseNum',
      banners: 'infoData/getBanners',
    })
  },
  mounted() {
    this.getTextBanners()
    eventBus.$on(liveInfoEventHandler, this.handleLiveInfoCall)
  },
  beforeDestroy() {
    eventBus.$off(liveInfoEventHandler, this.handleLiveInfoCall)
  },
  methods: {
    // 간편처방등록 완료 시 텍스트 배너에서 해당 건 즉시 제거
    handleLiveInfoCall({ funcName, p }) {
      if (funcName === 'LandingComplete' && p.liveInfoId) {
        const liveInfoId = Number(p.liveInfoId)
        // contentType 8(간편처방등록) + contentId === liveInfoId 인 배너만 제거
        this.textBanner = this.textBanner.filter(
          x => !(x.contentType === 8 && Number(x.contentId) === liveInfoId),
        )
      }
    },
    getTextBanners() {
      this.textBanner = this.banners.filter(x => x.bannerLocation === 11)
      if (this.textBanner.length >= 2) {
        const shuffled = [...this.textBanner].sort(() => Math.random() - 0.5)
        this.textBanner = shuffled.slice(0, 2)
      }
    },
    handleDrugInfoClick(contentId) {
      this.$emit('open-drug-info', contentId, SNT.A.Service_컨텐츠__약품정보, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleMedicalTrendClick(contentId) {
      this.$emit('open-medical-trend', contentId, SNT.A.Service_컨텐츠__메디컬트렌드, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleSurveyClick(contentId) {
      this.$emit('open-survey', contentId, SNT.A.Service_컨텐츠__설문조사, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleWebseminarClick(contentId) {
      this.$emit('open-webseminar', contentId, 1, SNT.A.Service_컨텐츠__웹세미나, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleNoticeClick(contentId) {
      this.$emit('open-notice', contentId, SNT.A.Service_컨텐츠__공지사항, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleEventClick(contentId) {
      this.$emit('open-event', contentId, SNT.A.Service_컨텐츠__이벤트, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleDrugLandingClick(contentId) {
      // (260429) 기존 수집 유지요청(w.김연수M). 다음 간편처방 전체 로직 수정 시 TextBanner용 Position 분리 예정
      // (260625) #208217: 간편처방등록 클릭 경로별 코드 분리 (김영도)
      this.$emit('open-drug-landing', contentId, SNT.A.Service_컨텐츠__간편처방등록, SNT.B.Position_닥터인포__메인____Body____홈__배너_텍스트_1, SNT.C.State_Action__클릭_컨텐츠)
    }
  }
}
</script>
